// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb_root__2JED5","list":"breadcrumb_list__1rKFi","separator":"breadcrumb_separator__17SkA","link":"breadcrumb_link__2MBaO"};